The input parameter for a signal representing the progression of a candidate or position through a recruitment process.
